export const communes = [
  { id: 1, name: 'LAS CONDES' },
  { id: 2, name: 'OVALLE' },
  { id: 3, name: 'COQUIMBO' },
  { id: 4, name: 'SAN MIGUEL' },
  { id: 5, name: 'SANTIAGO' },
  { id: 6, name: 'PROVIDENCIA' },
  { id: 7, name: 'INDEPENDENCIA' },
  { id: 8, name: 'ANTOFAGASTA' },
  { id: 9, name: 'LA CISTERNA' },
  { id: 10, name: 'OSORNO' },
  { id: 11, name: 'VALPARAISO' },
  { id: 12, name: 'NUNOA' },
  { id: 13, name: 'SAN ANTONIO' },
  { id: 14, name: 'CURICO' },
  { id: 15, name: 'LIMACHE' },
  { id: 16, name: 'LOS ANGELES' },
  { id: 17, name: 'CONCEPCION' },
  { id: 18, name: 'CARTAGENA' },
  { id: 19, name: 'MOLINA' },
  { id: 20, name: 'RANCAGUA' },
  { id: 21, name: 'CONCHALI' },
  { id: 22, name: 'SAN BERNARDO' },
  { id: 23, name: 'PIRQUE' },
  { id: 24, name: 'PENALOLEN' },
  { id: 25, name: 'COLINA' },
  { id: 26, name: 'MELIPILLA' },
  { id: 27, name: 'MACUL' },
  { id: 28, name: 'EL BOSQUE' },
  { id: 29, name: 'QUINTA NORMAL' },
  { id: 30, name: 'LA SERENA' },
  { id: 31, name: 'SANTA CRUZ' },
  { id: 32, name: 'CASABLANCA' },
  { id: 33, name: 'SAN FERNANDO' },
  { id: 34, name: 'LA FLORIDA' },
  { id: 35, name: 'PENCAHUE' },
  { id: 36, name: 'SAN FELIPE' },
  { id: 37, name: 'REQUINOA' },
  { id: 38, name: 'TALCAHUANO' },
  { id: 39, name: 'RECOLETA' },
  { id: 40, name: 'TALCA' },
  { id: 41, name: 'VINA DEL MAR' },
  { id: 42, name: 'LA LIGUA' },
  { id: 43, name: 'LO BARNECHEA' },
  { id: 44, name: 'CHILLAN' },
  { id: 45, name: 'ROMERAL' },
  { id: 46, name: 'PENAFLOR' },
  { id: 47, name: 'ARICA' },
  { id: 48, name: 'COPIAPO' },
  { id: 49, name: 'LA UNION' },
  { id: 50, name: 'TALAGANTE' },
  { id: 51, name: 'PLACILLA' },
  { id: 52, name: 'QUILLOTA' },
  { id: 53, name: 'PARRAL' },
  { id: 54, name: 'HIJUELAS' },
  { id: 55, name: 'PUTAENDO' },
  { id: 56, name: 'TEMUCO' },
  { id: 57, name: 'LA CALERA' },
  { id: 58, name: 'QUILPUE' },
  { id: 59, name: 'LA CRUZ' },
  { id: 60, name: 'VICUNA' },
  { id: 61, name: 'CAUQUENES' },
  { id: 62, name: 'EL QUISCO' },
  { id: 63, name: 'ALGARROBO' },
  { id: 64, name: 'LINARES' },
  { id: 65, name: 'PUERTO MONTT' },
  { id: 66, name: 'SAN JAVIER' },
  { id: 67, name: 'HUECHURABA' },
  { id: 68, name: 'BUIN' },
  { id: 69, name: 'SAN JOAQUIN' },
  { id: 70, name: 'SANTA MARIA' },
  { id: 71, name: 'MULCHEN' },
  { id: 72, name: 'GALVARINO' },
  { id: 73, name: 'SAN VICENTE T-T' },
  { id: 74, name: 'VILLARRICA' },
  { id: 75, name: 'FREIRE' },
  { id: 76, name: 'VITACURA' },
  { id: 77, name: 'VILLA ALEMANA' },
  { id: 78, name: 'PUENTE ALTO' },
  { id: 79, name: 'PUNTA ARENAS' },
  { id: 80, name: 'PADRE LAS CASAS' },
  { id: 81, name: 'PAREDONES' },
  { id: 82, name: 'SALAMANCA' },
  { id: 83, name: 'ANGOL' },
  { id: 84, name: 'EL CARMEN' },
  { id: 85, name: 'LOS ANDES' },
  { id: 86, name: 'SAN PEDRO DE LA PAZ' },
  { id: 87, name: 'LA REINA' },
  { id: 88, name: 'CERRILLOS' },
  { id: 89, name: 'TRAIGUEN' },
  { id: 90, name: 'OLIVAR' },
  { id: 91, name: 'ANDACOLLO' },
  { id: 92, name: 'PETORCA' },
  { id: 93, name: 'PUDAHUEL' },
  { id: 94, name: 'CERRO NAVIA' },
  { id: 95, name: 'LA GRANJA' },
  { id: 96, name: 'CURANILAHUE' },
  { id: 97, name: 'CABILDO' },
  { id: 98, name: 'EST CENTRAL' },
  { id: 99, name: 'VICTORIA' },
  { id: 100, name: 'EL TABO' },
  { id: 101, name: 'RENCA' },
  { id: 102, name: 'LO PRADO' },
  { id: 103, name: 'TEODORO SCHMIDT' },
  { id: 104, name: 'FLORIDA' },
  { id: 105, name: 'CON CON' },
  { id: 106, name: 'CALLE LARGA' },
  { id: 107, name: 'NANCAGUA' },
  { id: 108, name: 'NIQUEN' },
  { id: 109, name: 'LAMPA' },
  { id: 110, name: 'RIO BUENO' },
  { id: 111, name: 'VALDIVIA' },
  { id: 112, name: 'FRUTILLAR' },
  { id: 113, name: 'CONSTITUCION' },
  { id: 114, name: 'LONQUIMAY' },
  { id: 115, name: 'CALERA DE TANGO' },
  { id: 116, name: 'SAN RAMON' },
  { id: 117, name: 'FUTRONO' },
  { id: 118, name: 'PUMANQUE' },
  { id: 119, name: 'ALHUE' },
  { id: 120, name: 'RINCONADA' },
  { id: 121, name: 'CODEGUA' },
  { id: 122, name: 'PAINE' },
  { id: 123, name: 'PADRE HURTADO' },
  { id: 124, name: 'CHEPICA' },
  { id: 125, name: 'NOGALES' },
  { id: 126, name: 'MALLOA' },
  { id: 127, name: 'DONIHUE' },
  { id: 128, name: 'LONCOCHE' },
  { id: 129, name: 'PERALILLO' },
  { id: 130, name: 'QUINTA TILCOCO' },
  { id: 131, name: 'YUMBEL' },
  { id: 132, name: 'MAIPU' },
  { id: 133, name: 'PUERTO VARAS' },
  { id: 134, name: 'LLAY-LLAY' },
  { id: 135, name: 'SAN CARLOS' },
  { id: 136, name: 'SAN CLEMENTE' },
  { id: 137, name: 'TOME' },
  { id: 138, name: 'SAGRADA FAMILIA' },
  { id: 139, name: 'IQUIQUE' },
  { id: 140, name: 'CURACAVI' },
  { id: 141, name: 'SAN NICOLAS' },
  { id: 142, name: 'CALAMA' },
  { id: 143, name: 'RIO NEGRO' },
  { id: 144, name: 'MAULE' },
  { id: 145, name: 'CURACAUTIN' },
  { id: 146, name: 'CHIGUAYANTE' },
  { id: 147, name: 'LA PINTANA' },
  { id: 148, name: 'CATEMU' },
  { id: 149, name: 'HUALQUI' },
  { id: 150, name: 'CASTRO' },
  { id: 151, name: 'LO ESPEJO' },
  { id: 152, name: 'PUCON' },
  { id: 153, name: 'LEBU' },
  { id: 154, name: 'PUNITAQUI' },
  { id: 155, name: 'PICHILEMU' },
  { id: 156, name: 'VILCUN' },
  { id: 157, name: 'GRANEROS' },
  { id: 158, name: 'YUNGAY' },
  { id: 159, name: 'SAN RAFAEL' },
  { id: 160, name: 'ILLAPEL' },
  { id: 161, name: 'VILLA ALEGRE' },
  { id: 162, name: 'ZAPALLAR' },
  { id: 163, name: 'CANELA' },
  { id: 164, name: 'SAN PEDRO DE MELIPILLA' },
  { id: 165, name: 'MARCHIGUE' },
  { id: 166, name: 'PUREN' },
  { id: 167, name: 'SAN FCO DE MOSTAZAL' },
  { id: 168, name: 'CARAHUE' },
  { id: 169, name: 'CHAITEN' },
  { id: 170, name: 'COIHUECO' },
  { id: 171, name: 'CANETE' },
  { id: 172, name: 'SANTO DOMINGO' },
  { id: 173, name: 'EL MONTE' },
  { id: 174, name: 'MACHALI' },
  { id: 175, name: 'ANCUD' },
  { id: 176, name: 'CORONEL' },
  { id: 177, name: 'MEJILLONES' },
  { id: 178, name: 'SAN ESTEBAN' },
  { id: 179, name: 'VICHUQUEN' },
  { id: 180, name: 'MONTE PATRIA' },
  { id: 181, name: 'LAUTARO' },
  { id: 182, name: 'MARIA PINTO' },
  { id: 183, name: 'PUCHUNCAVI' },
  { id: 184, name: 'PICHIDEGUA' },
  { id: 185, name: 'PUERTO NATALES' },
  { id: 186, name: 'RENGO' },
  { id: 187, name: 'PALMILLA' },
  { id: 188, name: 'ARAUCO' },
  { id: 189, name: 'NUEVA IMPERIAL' },
  { id: 190, name: 'LUMACO' },
  { id: 191, name: 'LOS MUERMOS' },
  { id: 192, name: 'QUIRIHUE' },
  { id: 193, name: 'OLMUE' },
  { id: 194, name: 'CHONCHI' },
  { id: 195, name: 'COLLIPULLI' },
  { id: 196, name: 'TIL-TIL' },
  { id: 197, name: 'LAJA' },
  { id: 198, name: 'RAUCO' },
  { id: 199, name: 'ALTO HOSPICIO' },
  { id: 200, name: 'RANQUIL' },
  { id: 201, name: 'SAN PABLO' },
  { id: 202, name: 'RIO CLARO' },
  { id: 203, name: 'QUILLON' },
  { id: 204, name: 'TOCOPILLA' },
  { id: 205, name: 'SANTA BARBARA' },
  { id: 206, name: 'COCHRANE' },
  { id: 207, name: 'SAN JOSE MAIPO' },
  { id: 208, name: 'CHIMBARONGO' },
  { id: 209, name: 'QUILICURA' },
  { id: 210, name: 'PAPUDO' },
  { id: 211, name: 'PENCO' },
  { id: 212, name: 'LOS LAGOS' },
  { id: 213, name: 'LOS VILOS' },
  { id: 214, name: 'HUASCO' },
  { id: 215, name: 'PORVENIR' },
  { id: 216, name: 'COYHAIQUE' },
  { id: 217, name: 'PANGUIPULLI' },
  { id: 218, name: 'ISLA DE MAIPO' },
  { id: 219, name: 'EMPEDRADO' },
  { id: 220, name: 'PELLUHUE' },
  { id: 221, name: 'CUREPTO' },
  { id: 222, name: 'VALLENAR' },
  { id: 223, name: 'YERBAS BUENAS' },
  { id: 224, name: 'LOTA' },
  { id: 225, name: 'LAS CABRAS' },
  { id: 226, name: 'MARIQUINA' },
  { id: 227, name: 'QUILLECO' },
  { id: 228, name: 'COMBARBALA' },
  { id: 229, name: 'COLBUN' },
  { id: 230, name: 'PUTRE' },
  { id: 231, name: 'COLTAUCO' },
  { id: 232, name: 'PICA' },
  { id: 233, name: 'PEUMO' },
  { id: 234, name: 'ANTUCO' },
  { id: 235, name: 'RETIRO' },
  { id: 236, name: 'PANQUEHUE' },
  { id: 237, name: 'CISNES' },
  { id: 238, name: 'SAN IGNACIO' },
  { id: 239, name: 'HUALPEN' },
  { id: 240, name: 'QUINTERO' },
  { id: 241, name: 'RENAICO' },
  { id: 242, name: 'FREIRINA' },
  { id: 243, name: 'JUAN FERNANDEZ' },
  { id: 244, name: 'CHILLAN VIEJO' },
  { id: 245, name: 'HUALANE' },
  { id: 246, name: 'CUNCO' },
  { id: 247, name: 'PURRANQUE' },
  { id: 248, name: 'PUYEHUE' },
  { id: 249, name: 'LAGO RANCO' },
  { id: 250, name: 'FUTALEUFU' },
  { id: 251, name: 'COBQUECURA' },
  { id: 252, name: 'PUERTO OCTAY' },
  { id: 253, name: 'DALCAHUE' },
  { id: 254, name: 'CHANARAL' },
  { id: 255, name: 'LLANQUIHUE' },
  { id: 256, name: 'CALDERA' },
  { id: 257, name: 'DIEGO DE ALMAGRO' },
  { id: 258, name: 'CONTULMO' },
  { id: 259, name: 'TENO' },
  { id: 260, name: 'COELEMU' },
  { id: 261, name: 'BULNES' },
  { id: 262, name: 'RIO IBANEZ' },
  { id: 263, name: 'NACIMIENTO' },
  { id: 264, name: 'SAN GREGORIO' },
  { id: 265, name: 'PEMUCO' },
  { id: 266, name: 'LOS ALAMOS' },
  { id: 267, name: 'FRESIA' },
  { id: 268, name: 'TIMAUKEL' },
  { id: 269, name: 'LOLOL' },
  { id: 270, name: 'LA ESTRELLA' },
  { id: 271, name: 'PITRUFQUEN' },
  { id: 272, name: 'COINCO' },
  { id: 273, name: 'RIO HURTADO' },
  { id: 274, name: 'PAIHUANO' },
  { id: 275, name: 'GORBEA' },
  { id: 276, name: 'CHANCO' },
  { id: 277, name: 'PRIMAVERA' },
  { id: 278, name: 'NINHUE' },
  { id: 279, name: 'PELARCO' },
  { id: 280, name: 'AYSEN' },
  { id: 281, name: 'NEGRETE' },
  { id: 282, name: 'LANCO' },
  { id: 283, name: 'PAILLACO' },
  { id: 284, name: 'PORTEZUELO' },
  { id: 285, name: 'LONGAVI' },
  { id: 286, name: 'ALTO DEL CARMEN' },
  { id: 287, name: 'CABRERO' },
  { id: 288, name: 'TIRUA' },
  { id: 289, name: 'PINTO' },
  { id: 290, name: 'MAULLIN' },
  { id: 291, name: 'MAFIL' },
  { id: 292, name: 'TORRES DE PAINE' },
  { id: 293, name: 'SAN JUAN DE LA COSTA' },
  { id: 294, name: 'LITUECHE' },
  { id: 295, name: 'CALBUCO' },
  { id: 296, name: 'COCHAMO' },
  { id: 297, name: 'RIO VERDE' },
  { id: 298, name: 'SANTA JUANA' },
  { id: 299, name: 'SAN PEDRO DE ATACAMA' },
  { id: 300, name: 'HUALAIHUE' },
  { id: 301, name: 'NAVIDAD' },
  { id: 302, name: 'LOS SAUCES' },
  { id: 303, name: 'TOLTEN' },
  { id: 304, name: 'PERQUENCO' },
  { id: 305, name: 'PUQUELDON' },
  { id: 306, name: 'POZO ALMONTE' },
  { id: 307, name: 'QUILACO' },
  { id: 308, name: 'TIERRA AMARILLA' },
  { id: 309, name: 'QUELLON' },
  { id: 310, name: 'SIERRA GORDA' },
  { id: 311, name: 'SAN FABIAN' },
  { id: 312, name: 'LICANTEN' },
  { id: 313, name: 'QUINCHAO' },
  { id: 314, name: 'Sin Comuna' },
  { id: 315, name: 'TALTAL' },
  { id: 316, name: 'TREHUACO' },
  { id: 317, name: 'OLLAGUE' },
  { id: 318, name: 'LAGUNA BLANCA' },
  { id: 319, name: 'CAMINA' },
  { id: 320, name: 'ISLA DE PASCUA' },
  { id: 321, name: 'CORRAL' },
  { id: 322, name: 'CHILE CHICO' },
  { id: 323, name: 'CABO DE HORNOS' },
  { id: 324, name: 'SAAVEDRA' },
  { id: 325, name: 'PALENA' },
  { id: 326, name: 'TUCAPEL' },
  { id: 327, name: 'ALTO BIO BIO' },
  { id: 328, name: 'QUEILEN' },
  { id: 329, name: 'CAMARONES' },
  { id: 330, name: 'QUEMCHI' },
  { id: 331, name: 'CHOLCHOL' },
  { id: 332, name: 'MARIA ELENA' },
  { id: 333, name: 'MELIPEUCO' },
  { id: 334, name: 'HUARA' },
  { id: 335, name: 'CURARREHUE' },
  { id: 336, name: 'CURACO DE VELEZ' },
  { id: 337, name: 'OHIGGINS' },
  { id: 338, name: 'LA HIGUERA' },
  { id: 339, name: 'ERCILLA' },
  { id: 340, name: 'TORTEL' },
  { id: 341, name: 'GENERAL LAGOS' },
  { id: 342, name: 'LAGO VERDE' },
  { id: 343, name: 'GUAITECAS' },
  { id: 344, name: 'SAN ROSENDO' },
  { id: 345, name: 'COLCHANE' },
  { id: 346, name: 'ANTARTIDA' },
];

export const regions = [
  { id: 1, name: 'XIII REGION METROPOLITANA' },
  { id: 2, name: 'IV REGION COQUIMBO' },
  { id: 3, name: 'II REGION DE ANTOFAGASTA' },
  { id: 4, name: 'X REGION LOS LAGOS' },
  { id: 5, name: 'V REGION VALPARAISO' },
  { id: 6, name: 'VII REGION DEL MAULE' },
  { id: 7, name: 'VIII REGION DEL BIO BIO' },
  { id: 8, name: `VI REGION DEL LIBERTADOR GENERAL BERNARDO O'HIGGINS` },
  { id: 9, name: 'XVI REGION DE ÑUBLE' },
  { id: 10, name: 'XV REGION ARICA Y PARINACOTA' },
  { id: 11, name: 'III REGION DE ATACAMA' },
  { id: 12, name: 'XIV REGION DE LOS RIOS' },
  { id: 13, name: 'IX REGION DE LA ARAUCANIA' },
  { id: 14, name: 'XII REGION DE MAGALLANES Y LA ANTARTICA CHILENA' },
  { id: 15, name: 'I REGION DE TARAPACA' },
  { id: 16, name: 'XI REGION AYSEN DEL GENERAL CARLOS IBAÑEZ DEL CAMPO' },
  { id: 17, name: 'Sin Información' },
];

export const provinces = [
  { id: 1, name: 'Arica' },
  { id: 2, name: 'Parinacota' },
  { id: 3, name: 'Iquique' },
  { id: 4, name: 'Tamarugal' },
  { id: 7, name: 'Tocopilla' },
  { id: 6, name: 'El Loa' },
  { id: 5, name: 'Antofagasta' },
  { id: 9, name: 'Chañaral' },
  { id: 8, name: 'Copiapó' },
  { id: 10, name: 'Huasco' },
  { id: 11, name: 'Elqui' },
  { id: 12, name: 'Limarí' },
  { id: 13, name: 'Choapa' },
  { id: 14, name: 'Petorca' },
  { id: 15, name: 'Los Andes' },
  { id: 16, name: 'San Felipe de Aconcagua' },
  { id: 17, name: 'Quillota' },
  { id: 18, name: 'Valparaíso' },
  { id: 19, name: 'San Antonio' },
  { id: 20, name: 'Isla de Pascua' },
  { id: 21, name: 'Marga Marga' },
  { id: 22, name: 'Chacabuco' },
  { id: 23, name: 'Santiago' },
  { id: 24, name: 'Cordillera' },
  { id: 25, name: 'Maipo' },
  { id: 26, name: 'Melipilla' },
  { id: 27, name: 'Talagante' },
  { id: 28, name: 'Cachapoal' },
  { id: 29, name: 'Colchagua' },
  { id: 30, name: 'Cardenal Caro' },
  { id: 31, name: 'Curicó' },
  { id: 32, name: 'Talca' },
  { id: 33, name: 'Linares' },
  { id: 34, name: 'Cauquenes' },
  { id: 35, name: 'Diguillín' },
  { id: 36, name: 'Itata' },
  { id: 37, name: 'Punilla' },
  { id: 38, name: 'Biobío' },
  { id: 39, name: 'Concepción' },
  { id: 40, name: 'Arauco' },
  { id: 41, name: 'Malleco' },
  { id: 42, name: 'Cautín' },
  { id: 43, name: 'Valdivia' },
  { id: 44, name: 'Ranco' },
  { id: 45, name: 'Osorno' },
  { id: 46, name: 'Llanquihue' },
  { id: 47, name: 'Chiloe' },
  { id: 48, name: 'Palena' },
  { id: 49, name: 'Coyhaique' },
  { id: 50, name: 'Aysén' },
  { id: 51, name: 'General Carrera' },
  { id: 52, name: 'General Prat' },
  { id: 53, name: 'Última Esperanza' },
  { id: 54, name: 'Magallanes' },
  { id: 55, name: 'Tierra del Fuego' },
  { id: 56, name: 'Antártica Chilena' },
];

export const companySizes = [
  { id: 1, name: 'Sin información' },
  { id: 2, name: 'Micro Empresa I' },
  { id: 3, name: 'Micro Empresa II' },
  { id: 4, name: 'Micro Empresa III' },
  { id: 5, name: 'Pequeña Empresa I' },
  { id: 6, name: 'Pequeña Empresa II' },
  { id: 7, name: 'Pequeña Empresa III' },
  { id: 8, name: 'Mediana Empresa I' },
  { id: 9, name: 'Mediana Empresa II' },
  { id: 10, name: 'Gran Empresa I' },
  { id: 11, name: 'Gran Empresa II' },
  { id: 12, name: 'Gran Empresa III' },
  { id: 13, name: 'Gran Empresa IV' },
];

export const economicSectors = [
  {
    id: 1,
    name: 'ACTIVIDADES DE ATENCION DE LA SALUD HUMANA Y DE ASISTENCIA SOCIAL',
  },
  { id: 2, name: 'TRANSPORTE Y ALMACENAMIENTO' },
  { id: 3, name: 'INDUSTRIA MANUFACTURERA' },
  { id: 4, name: 'ACTIVIDADES DE ALOJAMIENTO Y DE SERVICIO DE COMIDAS' },
  { id: 5, name: 'OTRAS ACTIVIDADES DE SERVICIOS' },
  {
    id: 6,
    name: 'COMERCIO AL POR MAYOR Y AL POR MENOR; REPARACION DE VEHICULOS AUTOMOTORES Y MOTOCICLETAS',
  },
  { id: 7, name: 'ACTIVIDADES INMOBILIARIAS' },
  { id: 8, name: 'ACTIVIDADES DE SERVICIOS ADMINISTRATIVOS Y DE APOYO' },
  { id: 9, name: 'ACTIVIDADES PROFESIONALES, CIENTIFICAS Y TECNICAS' },
  { id: 10, name: 'INFORMACION Y COMUNICACIONES' },
  { id: 11, name: 'AGRICULTURA, GANADERIA, SILVICULTURA Y PESCA' },
  { id: 12, name: 'ENSEÑANZA' },
  { id: 13, name: 'ACTIVIDADES FINANCIERAS Y DE SEGUROS' },
  { id: 14, name: 'CONSTRUCCION' },
  { id: 15, name: 'ACTIVIDADES ARTISTICAS, DE ENTRETENIMIENTO Y RECREATIVAS' },
  { id: 16, name: 'EXPLOTACION DE MINAS Y CANTERAS' },
  {
    id: 17,
    name: 'SUMINISTRO DE ELECTRICIDAD, GAS, VAPOR Y AIRE ACONDICIONADO',
  },
  {
    id: 18,
    name: 'SUMINISTRO DE AGUA; EVACUACION DE AGUAS RESIDUALES, GESTION DE DESECHOS Y DESCONTAMINACION',
  },
  {
    id: 19,
    name: 'ACTIVIDADES DE ORGANIZACIONES Y ORGANOS EXTRATERRITORIALES',
  },
  {
    id: 20,
    name: 'ADMINISTRACION PUBLICA Y DEFENSA; PLANES DE SEGURIDAD SOCIAL DE AFILIACION OBLIGATORIA',
  },
  {
    id: 21,
    name: 'ACTIVIDADES DE LOS HOGARES COMO EMPLEADORES; ACTIVIDADES NO DIFERENCIADAS DE LOS HOGARES',
  },
];

export const economicSubSectors = [
  { id: 1, name: 'OTRAS ACTIVIDADES DE ATENCION EN INSTITUCIONES' },
  { id: 2, name: 'OTRAS ACTIVIDADES DE TRANSPORTE POR VIA TERRESTRE' },
  {
    id: 3,
    name: 'FABRICACION DE PRODUCTOS METALICOS PARA USO ESTRUCTURAL, TANQUES, DEPOSITOS, RECIPIENTES DE METAL',
  },
  { id: 4, name: 'ACTIVIDADES DE RESTAURANTES Y DE SERVICIO MOVIL DE COMIDAS' },
  { id: 5, name: 'ACTIVIDADES DE OTRAS ASOCIACIONES' },
  {
    id: 6,
    name: 'VENTA AL POR MENOR DE ALIMENTOS, BEBIDAS Y TABACO EN COMERCIOS ESPECIALIZADOS',
  },
  {
    id: 7,
    name: 'VENTA AL POR MENOR DE OTROS PRODUCTOS EN COMERCIOS ESPECIALIZADOS',
  },
  { id: 8, name: 'FABRICACION DE MUEBLES' },
  { id: 9, name: 'OTRAS ACTIVIDADES DE SERVICIOS PERSONALES' },
  {
    id: 10,
    name: 'ACTIVIDADES INMOBILIARIAS REALIZADAS CON BIENES PROPIOS O ARRENDADOS',
  },
  { id: 11, name: 'ACTIVIDADES DE SEGURIDAD PRIVADA' },
  { id: 12, name: 'MANTENIMIENTO Y REPARACION DE VEHICULOS AUTOMOTORES' },
  {
    id: 13,
    name: 'ACTIVIDADES DE ARQUITECTURA E INGENIERIA Y ACTIVIDADES CONEXAS DE CONSULTORIA TECNICA',
  },
  {
    id: 14,
    name: 'ACTIVIDADES DE PRODUCCION DE PELICULAS CINEMATOGRAFICAS, VIDEOS Y PROGRAMAS DE TELEVISION',
  },
  { id: 15, name: 'VENTA AL POR MENOR EN COMERCIOS NO ESPECIALIZADOS' },
  { id: 16, name: 'ACTIVIDADES DE SERVICIOS DE APOYO A LAS EMPRESAS N.C.P.' },
  { id: 17, name: 'GANADERIA' },
  {
    id: 18,
    name: 'VENTA AL POR MENOR DE PRODUCTOS CULTURALES Y RECREATIVOS EN COMERCIOS ESPECIALIZADOS',
  },
  { id: 19, name: 'OTRAS ACTIVIDADES DE ALOJAMIENTO' },
  { id: 20, name: 'FABRICACION DE VIDRIO Y PRODUCTOS DE VIDRIO' },
  {
    id: 21,
    name: 'EDICION DE LIBROS Y PUBLICACIONES PERIODICAS Y OTRAS ACTIVIDADES DE EDICION',
  },
  {
    id: 22,
    name: 'ACTIVIDADES DE PROGRAMACION INFORMATICA, CONSULTORIA INFORMATICA Y ACTIVIDADES CONEXAS',
  },
  {
    id: 23,
    name: 'VENTA AL POR MENOR DE OTROS ENSERES DOMESTICOS EN COMERCIOS ESPECIALIZADOS',
  },
  {
    id: 24,
    name: 'ACTIVIDADES DE CONTABILIDAD, TENEDURIA DE LIBROS Y AUDITORIA; CONSULTORIA FISCAL',
  },
  { id: 25, name: 'CULTIVO DE PLANTAS PERENNES' },
  { id: 26, name: 'ACTIVIDADES DE MEDICOS Y ODONTOLOGOS' },
  { id: 27, name: 'FABRICACION DE PRODUCTOS DE PLASTICO' },
  { id: 28, name: 'VENTA AL POR MAYOR NO ESPECIALIZADA' },
  { id: 29, name: 'FABRICACION DE PRODUCTOS DE CAUCHO' },
  {
    id: 30,
    name: 'FABRICACION DE OTROS PRODUCTOS ELABORADOS DE METAL; ACTIVIDADES DE SERVICIOS DE TRABAJO DE METALES',
  },
  {
    id: 31,
    name: 'ENSEÑANZA PREESCOLAR, PRIMARIA, SECUNDARIA CIENTIFICO HUMANISTA Y TECNICO PROFESIONAL',
  },
  { id: 32, name: 'FABRICACION DE EQUIPO DE TRANSPORTE N.C.P.' },
  {
    id: 33,
    name: 'SUMINISTRO DE COMIDAS POR ENCARGO Y OTRAS ACTIVIDADES DE SERVICIO DE COMIDAS',
  },
  { id: 34, name: 'VENTA AL POR MAYOR DE MAQUINARIA, EQUIPO Y MATERIALES' },
  {
    id: 35,
    name: 'FONDOS Y SOCIEDADES DE INVERSION Y ENTIDADES FINANCIERAS SIMILARES',
  },
  {
    id: 36,
    name: 'CULTIVO DE PRODUCTOS AGRICOLAS EN COMBINACION CON LA CRIA DE ANIMALES',
  },
  {
    id: 37,
    name: 'ALQUILER Y ARRENDAMIENTO DE OTROS TIPOS DE MAQUINARIA, EQUIPO Y BIENES TANGIBLES',
  },
  { id: 38, name: 'EXTRACCION DE MADERA' },
  { id: 39, name: 'FABRICACION DE PRENDAS DE VESTIR, EXCEPTO PRENDAS DE PIEL' },
  { id: 40, name: 'REPARACION DE EFECTOS PERSONALES Y ENSERES DOMESTICOS' },
  { id: 41, name: 'CULTIVO DE PLANTAS NO PERENNES' },
  {
    id: 42,
    name: 'OTRAS ACTIVIDADES PROFESIONALES, CIENTIFICAS Y TECNICAS N.C.P.',
  },
  {
    id: 43,
    name: 'IMPRESION Y ACTIVIDADES DE SERVICIOS RELACIONADAS CON LA IMPRESION',
  },
  { id: 44, name: 'PUBLICIDAD' },
  { id: 45, name: 'VENTA AL POR MAYOR DE ALIMENTOS, BEBIDAS Y TABACO' },
  {
    id: 46,
    name: 'VENTA AL POR MENOR NO REALIZADA EN COMERCIOS, PUESTOS DE VENTA O MERCADOS',
  },
  {
    id: 47,
    name: 'REPARACION DE PRODUCTOS ELABORADOS DE METAL, MAQUINARIA Y EQUIPO',
  },
  { id: 48, name: 'ELABORACION DE OTROS PRODUCTOS ALIMENTICIOS' },
  { id: 49, name: 'ELABORACION Y CONSERVACION DE CARNE' },
  { id: 50, name: 'ACTIVIDADES DE ALOJAMIENTO PARA ESTANCIAS CORTAS' },
  { id: 51, name: 'VENTA DE VEHICULOS AUTOMOTORES' },
  {
    id: 52,
    name: 'VENTA DE PARTES, PIEZAS Y ACCESORIOS PARA VEHICULOS AUTOMOTORES',
  },
  { id: 53, name: 'FABRICACION DE PRODUCTOS MINERALES NO METALICOS N.C.P.' },
  { id: 54, name: 'FABRICACION DE OTROS PRODUCTOS TEXTILES' },
  { id: 55, name: 'OTRAS ACTIVIDADES DE ATENCION DE LA SALUD HUMANA' },
  { id: 56, name: 'ACTIVIDADES DE CONSULTORIA DE GESTION' },
  { id: 57, name: 'ALMACENAMIENTO Y DEPOSITO' },
  { id: 58, name: 'VENTA AL POR MAYOR DE ENSERES DOMESTICOS' },
  { id: 59, name: 'ACTIVIDADES JURIDICAS' },
  {
    id: 60,
    name: 'ACTIVIDADES DE APOYO A LA AGRICULTURA Y LA GANADERIA Y ACTIVIDADES POSCOSECHA',
  },
  {
    id: 61,
    name: 'ACTIVIDADES INMOBILIARIAS REALIZADAS A CAMBIO DE UNA RETRIBUCION O POR CONTRATA',
  },
  { id: 62, name: 'OTRAS ACTIVIDADES ESPECIALIZADAS DE CONSTRUCCION' },
  { id: 63, name: 'FABRICACION DE CALZADO' },
  { id: 64, name: 'SERVICIOS DE APOYO A LA SILVICULTURA' },
  { id: 65, name: 'PROPAGACION DE PLANTAS' },
  { id: 66, name: 'ENSEÑANZA SUPERIOR' },
  { id: 67, name: 'FABRICACION DE COMPUTADORES Y EQUIPO PERIFERICO' },
  {
    id: 68,
    name: 'ACTIVIDADES DE ASOCIACIONES EMPRESARIALES, PROFESIONALES Y DE EMPLEADORES',
  },
  { id: 69, name: 'VENTA AL POR MENOR EN PUESTOS DE VENTA Y MERCADOS' },
  { id: 70, name: 'ACTIVIDADES DEPORTIVAS' },
  { id: 71, name: 'OTRAS ACTIVIDADES DE VENTA AL POR MAYOR ESPECIALIZADA' },
  { id: 72, name: 'FABRICACION DE OTROS PRODUCTOS QUIMICOS' },
  {
    id: 73,
    name: 'VENTA AL POR MAYOR DE MATERIAS PRIMAS AGROPECUARIAS Y ANIMALES VIVOS',
  },
  { id: 74, name: 'EXTRACCION DE PIEDRA, ARENA Y ARCILLA' },
  { id: 75, name: 'ACTIVIDADES DE APOYO AL TRANSPORTE' },
  { id: 76, name: 'TERMINACION Y ACABADO DE EDIFICIOS' },
  { id: 77, name: 'ACTIVIDADES DE LIMPIEZA' },
  {
    id: 78,
    name: 'FABRICACION DE PARTES, PIEZAS Y ACCESORIOS PARA VEHICULOS AUTOMOTORES',
  },
  { id: 79, name: 'ELABORACION DE BEBIDAS ALCOHOLICAS Y NO ALCOHOLICAS' },
  {
    id: 80,
    name: 'ELABORACION DE PRODUCTOS DE MOLINERIA, ALMIDONES Y PRODUCTOS DERIVADOS DEL ALMIDON',
  },
  {
    id: 81,
    name: 'FABRICACION DE MOTORES, GENERADORES Y TRANSFORMADORES ELECTRICOS, APARATOS DE DISTRIBUCION Y CONTROL',
  },
  {
    id: 82,
    name: 'CURTIDO Y ADOBO DE CUEROS; FABRICACION PRODUCTOS DE CUERO; ADOBO Y TEÑIDO DE PIELES',
  },
  { id: 83, name: 'ALQUILER Y ARRENDAMIENTO DE VEHICULOS AUTOMOTORES' },
  { id: 84, name: 'CONSTRUCCION DE PROYECTOS DE SERVICIO PUBLICO' },
  { id: 85, name: 'OTRAS ACTIVIDADES DE ESPARCIMIENTO Y RECREATIVAS' },
  {
    id: 86,
    name: 'INSTALACIONES ELECTRICAS, DE GASFITERIA Y OTRAS INSTALACIONES PARA OBRAS DE CONSTRUCCION',
  },
  {
    id: 87,
    name: 'FABRICACION DE GAS; DISTRIBUCION DE COMBUSTIBLES GASEOSOS POR TUBERIAS',
  },
  {
    id: 88,
    name: 'VENTA AL POR MENOR DE COMBUSTIBLES PARA VEHICULOS AUTOMOTORES EN COMERCIOS ESPECIALIZADOS',
  },
  {
    id: 89,
    name: 'ACTIVIDADES AUXILIARES DE SERVICIOS FINANCIEROS, EXCEPTO LAS DE SEGUROS Y FONDOS DE PENSIONES',
  },
  { id: 90, name: 'SILVICULTURA Y OTRAS ACTIVIDADES FORESTALES' },
  { id: 91, name: 'FABRICACION DE MAQUINARIA DE USO ESPECIAL' },
  { id: 92, name: 'FABRICACION DE MAQUINARIA DE USO GENERAL' },
  { id: 93, name: 'DEMOLICION Y PREPARACION DEL TERRENO' },
  {
    id: 94,
    name: 'FABRICACION DE PRODUCTOS DE MADERA, CORCHO, PAJA Y MATERIALES TRENZABLES',
  },
  { id: 95, name: 'ACTIVIDADES ESPECIALIZADAS DE DISEÑO' },
  { id: 96, name: 'PROGRAMACION Y TRANSMISIONES DE TELEVISION' },
  { id: 97, name: 'FABRICACION DE COMPONENTES Y TABLEROS ELECTRONICOS' },
  { id: 98, name: 'ELABORACION DE PRODUCTOS LACTEOS' },
  {
    id: 99,
    name: 'VENTA, MANTENIMIENTO Y REPARACION DE MOTOCICLETAS Y SUS PARTES, PIEZAS Y ACCESORIOS',
  },
  {
    id: 100,
    name: 'PROCESAMIENTO DE DATOS, HOSPEDAJE Y ACTIVIDADES CONEXAS; PORTALES WEB',
  },
  { id: 101, name: 'PESCA' },
  {
    id: 102,
    name: 'FABRICACION SUSTANCIAS QUIMICAS BASICAS, ABONOS Y COMPUESTOS DE NITROGENO, PLASTICOS Y CAUCHO SINT.',
  },
  { id: 103, name: 'CONSTRUCCION DE EDIFICIOS' },
  { id: 104, name: 'OTROS TIPOS DE ENSEÑANZA' },
  {
    id: 105,
    name: 'FABRICACION DE INSTRUMENTOS Y MATERIALES MEDICOS Y ODONTOLOGICOS',
  },
  { id: 106, name: 'ELABORACION DE PIENSOS PREPARADOS PARA ANIMALES' },
  { id: 107, name: 'FABRICACION DE ARTICULOS DE DEPORTE' },
  {
    id: 108,
    name: 'VENTA AL POR MAYOR A CAMBIO DE UNA RETRIBUCION O POR CONTRATA',
  },
  {
    id: 109,
    name: 'VENTA AL POR MENOR DE EQUIPO DE INFORMACION Y DE COMUNICACIONES EN COMERCIOS ESPECIALIZADOS',
  },
  {
    id: 110,
    name: 'ALQUILER Y ARRENDAMIENTO DE EFECTOS PERSONALES Y ENSERES DOMESTICOS',
  },
  { id: 111, name: 'ASERRADO Y ACEPILLADURA DE MADERA' },
  { id: 112, name: 'ACTIVIDADES DE AGENCIAS DE EMPLEO' },
  { id: 113, name: 'ACTIVIDADES ADMINISTRATIVAS Y DE APOYO DE OFICINA' },
  { id: 114, name: 'OTRAS INDUSTRIAS MANUFACTURERAS N.C.P.' },
  { id: 115, name: 'CAPTACION, TRATAMIENTO Y DISTRIBUCION DE AGUA' },
  {
    id: 116,
    name: 'ACTIVIDADES DE APOYO PARA LA EXPLOTACION DE OTRAS MINAS Y CANTERAS',
  },
  { id: 117, name: 'HILATURA, TEJEDURA Y ACABADO DE PRODUCTOS TEXTILES' },
  { id: 118, name: 'OTRAS ACTIVIDADES DE TELECOMUNICACIONES' },
  { id: 119, name: 'ACTIVIDADES VETERINARIAS' },
  { id: 120, name: 'REPRODUCCION DE GRABACIONES' },
  {
    id: 121,
    name: 'FABRICACION DE PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y OTROS METALES NO FERROSOS',
  },
  { id: 122, name: 'ACTIVIDADES DE SERVICIO DE BEBIDAS' },
  { id: 123, name: 'REPARACION DE COMPUTADORES Y EQUIPO DE COMUNICACIONES' },
  { id: 124, name: 'EXTRACCION Y PROCESAMIENTO DE COBRE' },
  { id: 125, name: 'FABRICACION DE JOYAS, BISUTERIA Y ARTICULOS CONEXOS' },
  { id: 126, name: 'EXTRACCION DE CARBON DE PIEDRA' },
  { id: 127, name: 'FABRICACION DE APARATOS DE USO DOMESTICO' },
  {
    id: 128,
    name: 'ACTIVIDADES DE AGENCIAS DE VIAJES Y OPERADORES TURISTICOS',
  },
  {
    id: 129,
    name: 'ACTIVIDADES DE ATENCION EN INSTITUCIONES PARA PERSONAS DE EDAD Y PERSONAS CON DISCAPACIDAD',
  },
  { id: 130, name: 'ACTIVIDADES DE JUEGOS DE AZAR Y APUESTAS' },
  { id: 131, name: 'ACTIVIDADES DE TELECOMUNICACIONES ALAMBRICAS' },
  { id: 132, name: 'OTRAS ACTIVIDADES DE SERVICIOS DE INFORMACION' },
  { id: 133, name: 'EXPLOTACION DE MINAS Y CANTERAS N.C.P.' },
  { id: 134, name: 'CONSTRUCCION DE BUQUES Y OTRAS EMBARCACIONES' },
  { id: 135, name: 'OTRAS ACTIVIDADES DE DOTACION DE RECURSOS HUMANOS' },
  { id: 136, name: 'ACTIVIDADES DE HOSPITALES PUBLICOS Y PRIVADOS' },
  { id: 137, name: 'CONSTRUCCION DE OTRAS OBRAS DE INGENIERIA CIVIL' },
  {
    id: 138,
    name: 'EXTRACCION DE MINERALES METALIFEROS NO FERROSOS, EXCEPTO COBRE',
  },
  { id: 139, name: 'FABRICACION DE OTROS TIPOS DE EQUIPO ELECTRICO' },
  { id: 140, name: 'CONSTRUCCION DE CARRETERAS Y LINEAS DE FERROCARRIL' },
  { id: 141, name: 'TRANSMISIONES DE RADIO' },
  { id: 142, name: 'ESTUDIOS DE MERCADO Y ENCUESTAS DE OPINION PUBLICA' },
  { id: 143, name: 'ENSAYOS Y ANALISIS TECNICOS' },
  { id: 144, name: 'ACTIVIDADES CREATIVAS, ARTISTICAS Y DE ENTRETENIMIENTO' },
  { id: 145, name: 'ACTIVIDADES POSTALES' },
  { id: 146, name: 'RECUPERACION DE MATERIALES' },
  { id: 147, name: 'FABRICACION DE PAPEL Y DE PRODUCTOS DE PAPEL' },
  { id: 148, name: 'ACTIVIDADES DE INVESTIGACION' },
  {
    id: 149,
    name: 'ELABORACION DE ACEITES Y GRASAS DE ORIGEN VEGETAL Y ANIMAL',
  },
  {
    id: 150,
    name: 'OTRAS ACTIVIDADES DE SERVICIOS FINANCIEROS, EXCEPTO LAS DE SEGUROS Y FONDOS DE PENSIONES',
  },
  {
    id: 151,
    name: 'FABRICACION DE PRODUCTOS FARMACEUTICOS, SUSTANCIAS QUIMICAS MEDICINALES Y PRODUCTOS BOTANICOS',
  },
  { id: 152, name: 'ACUICULTURA' },
  { id: 153, name: 'ACTIVIDADES DE TELECOMUNICACIONES POR SATELITE' },
  {
    id: 154,
    name: 'ELABORACION Y CONSERVACION DE FRUTAS, LEGUMBRES Y HORTALIZAS',
  },
  { id: 155, name: 'ACTIVIDADES DE APOYO A LA ENSEÑANZA' },
  { id: 156, name: 'ORGANIZACION DE CONVENCIONES Y EXPOSICIONES COMERCIALES' },
  {
    id: 157,
    name: 'ACTIVIDADES AUXILIARES DE LAS ACTIVIDADES DE SEGUROS Y FONDOS DE PENSIONES',
  },
  { id: 158, name: 'TRANSPORTE DE PASAJEROS POR VIA AEREA' },
  {
    id: 159,
    name: 'FABRICACION DE CARROCERIAS PARA VEHICULOS AUTOMOTORES; FABRICACION DE REMOLQUES Y SEMIRREMOLQUES',
  },
  {
    id: 160,
    name: 'INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIAS NATURALES Y LA INGENIERIA',
  },
  { id: 161, name: 'FABRICACION DE EQUIPO ELECTRICO DE ILUMINACION' },
  { id: 162, name: 'OTROS SERVICIOS DE RESERVAS Y ACTIVIDADES CONEXAS' },
  {
    id: 163,
    name: 'ACTIVIDADES DE DESCONTAMINACION Y OTROS SERVICIOS DE GESTION DE DESECHOS',
  },
  { id: 164, name: 'TRANSPORTE MARITIMO Y DE CABOTAJE' },
  { id: 165, name: 'EVACUACION DE AGUAS RESIDUALES' },
  { id: 166, name: 'ACTIVIDADES DE AGENCIAS DE EMPLEO TEMPORAL' },
  { id: 167, name: 'RECOGIDA DE DESECHOS' },
  { id: 168, name: 'TRANSPORTE POR VIAS DE NAVEGACION INTERIORES' },
  {
    id: 169,
    name: 'ELABORACION Y CONSERVACION DE PESCADO, CRUSTACEOS Y MOLUSCOS',
  },
  { id: 170, name: 'INSTALACION DE MAQUINARIA Y EQUIPOS INDUSTRIALES' },
  {
    id: 171,
    name: 'ACTIVIDADES DE ORGANIZACIONES Y ORGANOS EXTRATERRITORIALES',
  },
  { id: 172, name: 'SUMINISTRO DE VAPOR Y DE AIRE ACONDICIONADO' },
  {
    id: 173,
    name: 'ACTIVIDADES DE BIBLIOTECAS, ARCHIVOS Y MUSEOS Y OTRAS ACTIVIDADES CULTURALES',
  },
  {
    id: 174,
    name: 'RECOLECCION DE PRODUCTOS FORESTALES DISTINTOS DE LA MADERA',
  },
  { id: 175, name: 'FONDOS DE PENSIONES' },
  {
    id: 176,
    name: 'ACTIVIDADES DE CAMPAMENTOS, PARQUES DE VEHICULOS DE RECREO Y PARQUES DE CARAVANAS',
  },
  {
    id: 177,
    name: 'ACTIVIDADES DE ATENCION EN INSTITUCIONES PARA PERSONAS CON DISCAPACIDAD MENTAL Y TOXICOMANOS',
  },
  { id: 178, name: 'FUNDICION DE METALES' },
  { id: 179, name: 'ACTIVIDADES DE SINDICATOS' },
  { id: 180, name: 'ACTIVIDADES DE GESTION DE FONDOS' },
  { id: 181, name: 'ACTIVIDADES DE TELECOMUNICACIONES INALAMBRICAS' },
  {
    id: 182,
    name: 'ADMINISTRACION DEL ESTADO Y APLICACION DE LA POLITICA ECONOMICA Y SOCIAL DE LA COMUNIDAD',
  },
  { id: 183, name: 'PRESTACION DE SERVICIOS A LA COMUNIDAD EN GENERAL' },
  { id: 184, name: 'ACTIVIDADES DE SERVICIOS DE SISTEMAS DE SEGURIDAD' },
  { id: 185, name: 'OTRAS ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO' },
  { id: 186, name: 'ACTIVIDADES DE SOCIEDADES DE CARTERA' },
  { id: 187, name: 'ACTIVIDADES DE OFICINAS PRINCIPALES' },
  {
    id: 188,
    name: 'GENERACION, TRANSMISION Y DISTRIBUCION DE ENERGIA ELECTRICA',
  },
  {
    id: 189,
    name: 'INVESTIGACIONES Y DESARROLLO EXPERIMENTAL EN EL CAMPO DE LAS CIENCIAS SOCIALES Y LAS HUMANIDADES',
  },
  {
    id: 190,
    name: 'ACTIVIDADES DE ASISTENCIA SOCIAL SIN ALOJAMIENTO PARA PERSONAS DE EDAD Y PERSONAS CON DISCAPACIDAD',
  },
  {
    id: 191,
    name: 'ACTIVIDADES DE PAISAJISMO Y SERVICIOS DE MANTENIMIENTO CONEXOS',
  },
  {
    id: 192,
    name: 'ARRENDAMIENTO DE PROPIEDAD INTELECTUAL Y SIMILARES, EXCEPTO OBRAS PROTEGIDAS POR DERECHOS DE AUTOR',
  },
  {
    id: 193,
    name: 'ACTIVIDADES DE LOS HOGARES COMO EMPLEADORES DE PERSONAL DOMESTICO',
  },
  { id: 194, name: 'INTERMEDIACION MONETARIA' },
  { id: 195, name: 'TRANSPORTE DE CARGA POR VIA AEREA' },
  { id: 196, name: 'TRANSPORTE POR TUBERIAS' },
  {
    id: 197,
    name: 'ACTIVIDADES DE APOYO PARA LA EXTRACCION DE PETROLEO Y GAS NATURAL',
  },
  { id: 198, name: 'EXTRACCION DE MINERALES DE HIERRO' },
  {
    id: 199,
    name: 'FABRICACION DE EQUIPO DE MEDICION, PRUEBA, NAVEGACION Y CONTROL Y DE RELOJES',
  },
  { id: 200, name: 'ACTIVIDADES COMBINADAS DE APOYO A INSTALACIONES' },
  { id: 201, name: 'FABRICACION DE ARTICULOS DE PUNTO Y GANCHILLO' },
  { id: 202, name: 'ACTIVIDADES DE CALL-CENTER' },
  { id: 203, name: 'FABRICACION DE ARTICULOS DE PIEL' },
  { id: 204, name: 'FABRICACION DE JUEGOS Y JUGUETES' },
  { id: 205, name: 'ACTIVIDADES DE GRABACION DE SONIDO Y EDICION DE MUSICA' },
  {
    id: 206,
    name: 'FABRICACION DE EQUIPO DE IRRADIACION Y EQUIPO ELECTRONICO DE USO MEDICO Y TERAPEUTICO',
  },
  { id: 207, name: 'ACTIVIDADES DE FOTOGRAFIA' },
  {
    id: 208,
    name: 'ACTIVIDADES DE PLANES DE SEGURIDAD SOCIAL DE AFILIACION OBLIGATORIA',
  },
  { id: 209, name: 'TRATAMIENTO Y ELIMINACION DE DESECHOS' },
  { id: 210, name: 'FABRICACION DE INSTRUMENTOS OPTICOS Y EQUIPO FOTOGRAFICO' },
  { id: 211, name: 'ACTIVIDADES DE MENSAJERIA' },
  { id: 212, name: 'ACTIVIDADES DE ATENCION DE ENFERMERIA EN INSTITUCIONES' },
  { id: 213, name: 'EDICION DE PROGRAMAS INFORMATICOS' },
  { id: 214, name: 'SEGUROS' },
  { id: 215, name: 'INDUSTRIAS BASICAS DE HIERRO Y ACERO' },
  { id: 216, name: 'FABRICACION DE LOCOMOTORAS Y MATERIAL RODANTE' },
  { id: 217, name: 'FABRICACION DE PRODUCTOS DE HORNOS DE COQUE' },
  {
    id: 218,
    name: 'CAZA ORDINARIA Y MEDIANTE TRAMPAS Y ACTIVIDADES DE SERVICIOS CONEXAS',
  },
  { id: 219, name: 'REASEGUROS' },
  { id: 220, name: 'EXTRACCION DE PETROLEO CRUDO' },
  { id: 221, name: 'FABRICACION DE FIBRAS ARTIFICIALES' },
  { id: 222, name: 'FABRICACION DE APARATOS ELECTRONICOS DE CONSUMO' },
  {
    id: 223,
    name: 'FABRICACION DE AERONAVES, NAVES ESPACIALES Y MAQUINARIA CONEXA',
  },
  { id: 224, name: 'FABRICACION DE EQUIPO DE COMUNICACIONES' },
  { id: 225, name: 'FABRICACION DE PRODUCTOS DE LA REFINACION DEL PETROLEO' },
  { id: 226, name: 'FABRICACION DE PILAS, BATERIAS Y ACUMULADORES' },
  { id: 227, name: 'TRANSPORTE POR FERROCARRIL' },
  { id: 228, name: 'FABRICACION DE INSTRUMENTOS MUSICALES' },
  { id: 229, name: 'FABRICACION DE CABLES Y DISPOSITIVOS DE CABLEADO' },
  { id: 230, name: 'ELABORACION DE PRODUCTOS DE TABACO' },
  { id: 231, name: 'FABRICACION DE VEHICULOS AUTOMOTORES' },
  { id: 232, name: 'EXTRACCION DE GAS NATURAL' },
  { id: 233, name: 'FABRICACION DE SOPORTES MAGNETICOS Y OPTICOS' },
];
